module.exports = __webpack_public_path__ + "img/flowPath.4cfcda15.png";